module.exports = __webpack_public_path__ + "static/media/me3_RightCircle_Icon.9339e0cd.png";